import * as React from 'react';
import { Button, Popup } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import './FlowDesign.scss';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import LimitHitWarning from 'components/form/trident-campaigns/LimitHitWarning';

export default class ActionWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const buttonAction = {
      width: 150,
      height: 60,
      borderRadius: 60,
      border: '1px solid #d6bbf3',
      backgroundColor: '#f9f0ff',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const buttonActionClicked = {
      width: 150,
      height: 60,
      borderRadius: 60,
      border: '1px solid #ac73fb',
      backgroundColor: '#debefc',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    // preparing ancestor list of current clicked node to send it into node preview display.
    const ancestorList = _.concat(this.props.parentKeyList, this.props.currentNodeKey);
    const parentKey = this.props.parentKeyList[this.props.parentKeyList.length - 1];
    const randomizeRange = _.get(this.props.model.nodes[this.props.currentNodeKey], 'randomizeRange');
    let defaultName = getDefaultNodeName(this.props.currentNodeKey, nodeTypes.actions, _.get(this.props.model, 'nodesOccMap'));
    if (randomizeRange && randomizeRange.length > 0) {
      defaultName = defaultName + ` (${randomizeRange[1] - randomizeRange[0]}%)`;
    }
    return (
      <div className={_.get(this.props.model.nodes[parentKey], 'children', []).length > 1 ? 'entry' : 'entry sole'}>
        <div style={{position: 'absolute', left: '130px', top: '10px', zIndex : 1000}}>
          <LimitHitWarning content={'Total limit hit'}
                           usage={_.get(this.props.model, `usage.actionUsages.${this.props.currentNodeKey}.total`)}
                           limit={_.result( _.find( _.get(this.props.model, `nodes.${this.props.currentNodeKey}.limits`), (obj) => obj.per === "total" ), "limit")} />
        </div>
        <span className="wrapDesign">
          <Popup
            trigger={
              <Button style={this.props.clickedNode === this.props.currentNodeKey ? buttonActionClicked : buttonAction} onClick={() => this.props.handleNodePreview(ancestorList, this.props.currentNodeKey)}>
                {_.get(this.props.model.nodes[this.props.currentNodeKey], 'name', defaultName) || defaultName}
              </Button>
            }
            content={getNodePopupContent(this.props.model, 'name', this.props.currentNodeKey, defaultName)}
          />
        </span>
      </div>
    );
  }
}
